import { defaultAuth } from '@/library/firebase'
import * as types from './mutation-types'

const state = {
  login: {}
}

const getters = {}

const actions = {
  async [types.CHECK_LOGIN]({ dispatch }) {
    return new Promise((resolve, reject) => {
      defaultAuth.onAuthStateChanged(user => {
        if (user) {
          // defaultAuth.currentUser.getIdToken(/* forceRefresh */ true).then((idToken) => {
          //     // console.log('Bearer ' + idToken)
          // }).catch((e) => {
          //     reject(e)
          // })
          dispatch(types.GET_USERINFO, { uid: user.uid })
            .then(() => {
              resolve(true)
            })
            .catch(e => {
              reject(`${e} 로그인 정보 저장 실패, 관리자에게 문의해주세요.`)
            })
        } else {
          resolve(false)
        }
      })
    })
  },
  async [types.LOGIN_OUT]({ dispatch }) {
    defaultAuth
      .signOut()
      .then(() => {
        dispatch(types.CLEAR_USER)
      })
      .catch(error => {
        alert('logout fails \n code: ' + error)
      })
  }
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
